const STATUS_KEY_MAP = Object.freeze({
	SHOW: "show",
	HIDE: "hide",
});

function normalizeCustomers(customers) {
	if (!Array.isArray(customers)) {
		return [];
	}

	return customers.map((customer) => ({
		customer_id: customer && customer.customer_id ? customer.customer_id : "",
		customer_name: customer && customer.customer_name ? customer.customer_name : "",
	}));
}

function normalizeOpenClawUsers(users) {
	if (!Array.isArray(users)) {
		return [];
	}

	return users.map((user) => ({
		user_id: user && user.user_id ? user.user_id : "",
		guest_name: user && user.guest_name ? user.guest_name : "",
		guest_phone_number: user && user.guest_phone_number ? user.guest_phone_number : "",
		access_status: Boolean(user && user.access_status),
		customers: normalizeCustomers(user && user.customers),
	}));
}

function getStatusKey(accessStatus) {
	return accessStatus ? STATUS_KEY_MAP.SHOW : STATUS_KEY_MAP.HIDE;
}

function getActionKey(accessStatus) {
	return accessStatus ? STATUS_KEY_MAP.HIDE : STATUS_KEY_MAP.SHOW;
}

function getStatusText(accessStatus, translate) {
	return translate(`openClawManagement.${getStatusKey(accessStatus)}`);
}

function getActionText(accessStatus, translate) {
	return translate(`openClawManagement.${getActionKey(accessStatus)}`);
}

function getNextAccessStatus(accessStatus) {
	return !accessStatus;
}

function getRestaurantIds(customers) {
	return normalizeCustomers(customers)
		.map((customer) => customer.customer_id)
		.filter(Boolean);
}

function getRestaurantNames(customers) {
	return normalizeCustomers(customers)
		.map((customer) => customer.customer_name)
		.filter(Boolean);
}

module.exports = {
	getActionKey,
	getActionText,
	getNextAccessStatus,
	getRestaurantIds,
	getRestaurantNames,
	getStatusKey,
	getStatusText,
	normalizeCustomers,
	normalizeOpenClawUsers,
};
